import React from 'react'
import LoadingPath from '../../../assets/img/loading-pinwheel.gif'

type LoadingProp = {
	size: number
}

export const Loading: React.FC<LoadingProp> = ({ size }) => {
	return (
		<div style={{ position: 'absolute' }} className='Loading'>
			<img src={LoadingPath} width={size} height={size} alt='loading...' />
		</div>
	)
}
